/* ── Fleet categories ──────────────────────────────────── */
export const FLEET_CATEGORIES = [
  { id: 'all',      label: 'All categories' },
  { id: 'soundbox', label: 'Soundbox' },
  { id: 'pos',      label: 'POS' },
  { id: 'kiosk',    label: 'Kiosk' },
];

/* ── Fleets ────────────────────────────────────────────── */
export const FLEETS = [
  { id: 'f1', name: 'EaseBuzz_SB_Fleet',  category: 'Soundbox', categoryId: 'soundbox', activeDevices: 642,  inactiveDevices: 9454, online: 642,  offline: 9454, devices: 10096 },
  { id: 'f2', name: 'APB_SB_Fleet',       category: 'Soundbox', categoryId: 'soundbox', activeDevices: 90,   inactiveDevices: 84,   online: 6,    offline: 84,   devices: 90   },
  { id: 'f3', name: 'Walklab_V2_Fleet',   category: 'Soundbox', categoryId: 'soundbox', activeDevices: 0,    inactiveDevices: 5,    online: 0,    offline: 5,    devices: 5    },
  { id: 'f4', name: 'DGS_Fleet',          category: 'POS',      categoryId: 'pos',      activeDevices: 0,    inactiveDevices: 1,    online: 0,    offline: 1,    devices: 1    },
  { id: 'f5', name: 'Innoviti_Fleet',     category: 'Kiosk',    categoryId: 'kiosk',    activeDevices: 0,    inactiveDevices: 20,   online: 0,    offline: 20,   devices: 20   },
  { id: 'f6', name: 'Paytm_SB_Fleet',    category: 'Soundbox', categoryId: 'soundbox', activeDevices: 120,  inactiveDevices: 380,  online: 120,  offline: 380,  devices: 500  },
  { id: 'f7', name: 'PhonePe_POS_Fleet', category: 'POS',      categoryId: 'pos',      activeDevices: 44,   inactiveDevices: 56,   online: 44,   offline: 56,   devices: 100  },
];

/* ── Devices ───────────────────────────────────────────── */
export const DEVICES = [
  { id: 'd1',  model: 'SB-100', imei: '861234567890123', status: 'Online',  firmware: 'v2.1.4', customerApp: 'EaseBuzz', language: 'Hindi',   fleet: 'EaseBuzz_SB_Fleet'  },
  { id: 'd2',  model: 'SB-100', imei: '861234567890131', status: 'Offline', firmware: 'v2.1.3', customerApp: 'EaseBuzz', language: 'English',  fleet: 'EaseBuzz_SB_Fleet'  },
  { id: 'd3',  model: 'SB-200', imei: '861234567890149', status: 'Online',  firmware: 'v2.2.0', customerApp: 'APB',      language: 'Tamil',    fleet: 'APB_SB_Fleet'       },
  { id: 'd4',  model: 'SB-200', imei: '861234567890156', status: 'Online',  firmware: 'v2.2.0', customerApp: 'APB',      language: 'Hindi',    fleet: 'APB_SB_Fleet'       },
  { id: 'd5',  model: 'POS-X1', imei: '861234567890164', status: 'Offline', firmware: 'v1.9.1', customerApp: 'Innoviti', language: 'English',  fleet: 'Innoviti_Fleet'     },
  { id: 'd6',  model: 'SB-100', imei: '861234567890172', status: 'Online',  firmware: 'v2.1.4', customerApp: 'Paytm',   language: 'Hindi',    fleet: 'Paytm_SB_Fleet'     },
  { id: 'd7',  model: 'SB-100', imei: '861234567890180', status: 'Offline', firmware: 'v2.1.2', customerApp: 'Paytm',   language: 'Hindi',    fleet: 'Paytm_SB_Fleet'     },
  { id: 'd8',  model: 'POS-X2', imei: '861234567890198', status: 'Online',  firmware: 'v3.0.1', customerApp: 'PhonePe', language: 'English',  fleet: 'PhonePe_POS_Fleet'  },
  { id: 'd9',  model: 'SB-300', imei: '861234567890206', status: 'Online',  firmware: 'v2.3.0', customerApp: 'EaseBuzz', language: 'Tamil',   fleet: 'EaseBuzz_SB_Fleet'  },
  { id: 'd10', model: 'SB-100', imei: '861234567890214', status: 'Offline', firmware: 'v2.1.1', customerApp: 'APB',      language: 'English', fleet: 'APB_SB_Fleet'       },
];

/* ── Initial advertisements ────────────────────────────── */
export const INITIAL_ADVERTISEMENTS = [
  {
    id: 1,
    advId:    'ADV-202609-001',
    name:     'Festival Campaign — Hindi',
    fleet:    'EaseBuzz_SB_Fleet',
    schedule: '2 slots/day · Every 2 days · 09:00–16:00',
    devices:  10096,
    status:   'Running',
    played:   7842,
    missed:   120,
    date:     '2026-09-05',
  },
  {
    id: 2,
    advId:    'ADV-202609-002',
    name:     'Diwali Promo — Tamil',
    fleet:    'APB_SB_Fleet',
    schedule: '1 slot/day · Daily · 10:00–12:00',
    devices:  90,
    status:   'Scheduled',
    played:   null,
    missed:   null,
    date:     '2026-10-01',
  },
  {
    id: 3,
    advId:    'ADV-202608-003',
    name:     'Independence Day Special',
    fleet:    'Paytm_SB_Fleet',
    schedule: '3 slots/day · Weekly · 08:00–20:00',
    devices:  500,
    status:   'Final results',
    played:   1420,
    missed:   80,
    date:     '2026-08-10',
  },
];

/* ── Device log (for report page) ──────────────────────── */
export const INITIAL_DEVICE_LOG = [
  { id: 'r1',  imei: '861234567890123', device: 'SB-100', date: '2026-09-05', scheduledWindow: '09:00–12:00', playedAt: '09:14',  result: 'Played',      duration: '0:32', ratePerMin: '5.0', rolledBack: false },
  { id: 'r2',  imei: '861234567890131', device: 'SB-100', date: '2026-09-05', scheduledWindow: '09:00–12:00', playedAt: '—',      result: 'Missed',      duration: '—',    ratePerMin: '—',   rolledBack: false },
  { id: 'r3',  imei: '861234567890149', device: 'SB-200', date: '2026-09-05', scheduledWindow: '14:00–16:00', playedAt: '14:03',  result: 'Played',      duration: '0:30', ratePerMin: '5.0', rolledBack: false },
  { id: 'r4',  imei: '861234567890156', device: 'SB-200', date: '2026-09-05', scheduledWindow: '14:00–16:00', playedAt: '14:55',  result: 'In progress', duration: '0:18', ratePerMin: '4.2', rolledBack: false },
  { id: 'r5',  imei: '861234567890164', device: 'POS-X1', date: '2026-09-05', scheduledWindow: '09:00–12:00', playedAt: '—',      result: 'Missed',      duration: '—',    ratePerMin: '—',   rolledBack: false },
  { id: 'r6',  imei: '861234567890172', device: 'SB-100', date: '2026-09-05', scheduledWindow: '09:00–12:00', playedAt: '10:22',  result: 'Played',      duration: '0:31', ratePerMin: '5.0', rolledBack: false },
  { id: 'r7',  imei: '861234567890180', device: 'SB-100', date: '2026-09-07', scheduledWindow: '09:00–12:00', playedAt: '09:45',  result: 'Played',      duration: '0:30', ratePerMin: '5.0', rolledBack: false },
  { id: 'r8',  imei: '861234567890198', device: 'POS-X2', date: '2026-09-07', scheduledWindow: '14:00–16:00', playedAt: '15:10',  result: 'In progress', duration: '0:12', ratePerMin: '3.8', rolledBack: false },
];

/* ── Report summary metrics ────────────────────────────── */
export const REPORT_METRICS = {
  selectedDevices: 10096,
  occurrences:     28,
  played:          7842,
  missed:          120,
};

/* ── Time-slot bar chart data ──────────────────────────── */
export const TIMESLOTS = [
  { label: '06:00–09:00', played: 820  },
  { label: '09:00–12:00', played: 2410 },
  { label: '12:00–15:00', played: 1890 },
  { label: '15:00–18:00', played: 2100 },
  { label: '18:00–21:00', played: 622  },
];

/* ── Device status breakdown ───────────────────────────── */
export const REPORT_DEVICE_STATUS = [
  { id: 's1', label: 'Played',      count: 7842, status: 'played'   },
  { id: 's2', label: 'In progress', count: 134,  status: 'progress' },
  { id: 's3', label: 'Missed',      count: 120,  status: 'missed'   },
];
